var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTerraform(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 80.8",
    width: 2228,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#000}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st0",
    d: "M25.4 14.3l21.4 12.4v24.7L25.4 39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    className: "st0",
    d: "M50.6 26.7L72 14.3V39L50.6 51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st0",
    d: "M0 0l21.4 12.4v24.7L0 24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    className: "st0",
    d: "M25.4 43.7L46.8 56v24.8L25.4 68.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerraform);
export default __webpack_public_path__ + "static/media/terraform.437d16f26162408e2ff28f0af804a9b2.svg";
export { ForwardRef as ReactComponent };